import React, { useState } from 'react'
import { View, Text, ScrollView } from 'react-native'
// import * as firebase from 'firebase/app'
import { useDispatch } from 'react-redux'
import tw from 'tailwind-rn'
import { StackNavigationProp } from '@react-navigation/stack'

import ActionCreators from '../../store/actions'
import { HGView, HGText, HGGroup, HGButton } from '../../components/HGUI'
import ModalSignIn from '../../components/HGModal/ModalSignIn'
import ChangePasswordForm, { ChangePasswordValues } from './ChangePasswordForm'
import { RootStackParamList } from '../../navigators/AppNavigator'

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
}

const UserChangePasswordScreen = (props: Props) => {
  const { navigation } = props
  const [modalSignInVisible, setModalSignInVisible] = useState(false)
  const [formSuccess, setFormSuccess] = useState(false)
  const dispatch = useDispatch()

  const performUserPasswordChange = (
    values: ChangePasswordValues,
    setSubmitting: (value: boolean) => void
  ) => {
    const { password } = values

    setModalSignInVisible(false)
    setSubmitting(true)

    dispatch(ActionCreators.changeUserPassword({ newPassword: password }))
      .then(() => {
        setFormSuccess(true)
      })
      .catch((/* reason */) => {
        dispatch(ActionCreators.handleError({ code: 'change-password/error' }))
        // if (reason.code && reason.code === 'auth/requires-recent-login') {
        //   setModalSignInVisible(true)
        // } else {
        //   dispatch(
        //     ActionCreators.handleError({ code: 'change-password/error' })
        //   )
        // }
      })
      .then(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <ModalSignIn
        visible={modalSignInVisible}
        onAbort={() => setModalSignInVisible(false)}
        onSuccess={() => performUserPasswordChange()}
      />
      <ScrollView>
        <HGView>
          <View style={tw('px-3')}>
            <HGGroup style={tw('mt-6')}>
              {!formSuccess && (
                <View>
                  <ChangePasswordForm onSubmit={performUserPasswordChange} />
                </View>
              )}

              {formSuccess && (
                <>
                  <View style={tw('flex items-center mb-3')}>
                    <Text style={tw('text-2xl')}>🔐</Text>
                  </View>
                  <HGText style={{ textAlign: 'center' }}>
                    Ihr Passwort wurde erfolgreich geändert.
                  </HGText>

                  <View style={tw('mt-6')} />
                  <HGButton
                    title="Zurück zum Profil"
                    onPress={() => navigation.popToTop()}
                  />
                </>
              )}
            </HGGroup>
          </View>
        </HGView>
      </ScrollView>
    </>
  )
}

export default UserChangePasswordScreen
